import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import { MyGroup } from '@/types/MyGroup.type';
import { ListItem } from '@mui/material';
import TreeItem from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { isBrowser } from 'react-device-detect';
import URL from '@/common/routes/Url';

interface Props {
  myGroup: Array<MyGroup>;
}

const MyGroupListItems: React.FC<Props> = ({ myGroup }) => {
  const navigate = useNavigate();

  const toActplan = (id: number) => {
    navigate(`${URL.actPlan}?myGroupId=${id}`);
  };

  const toMyGroupList = () => {
    navigate(URL.myGroups);
  };

  const [selected, setSelected] = useState<Array<string> | undefined>([]);
  const [searchParams] = useSearchParams();

  const handleSelect = (event: React.SyntheticEvent, nodeIds: Array<string>) => {
    setSelected(nodeIds);
  };

  useEffect(() => {
    if (searchParams.get('departmentId')) {
      setSelected([]);
    }
    if (searchParams.get('myGroupId')) {
      setSelected([searchParams.get('myGroupId') as string]);
    }
  }, [searchParams.get('departmentId'), searchParams.get('myGroupId')]);

  return (
    <List disablePadding>
      <ListItem>
        <ListItemText primary="Myグループ" sx={{ pl: 1 }} />
        {/* スマホの場合は編集アイコンを非表示とする */}
        {isBrowser && (
          <Tooltip title="Myグループの編集を行う" placement="top" arrow>
            <IconButton edge="end" aria-label="edit" onClick={() => toMyGroupList()}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        )}
      </ListItem>
      <TreeView aria-label="file system navigator" onNodeSelect={handleSelect} selected={selected}>
        {myGroup.map((row) => (
          <TreeItem
            key={row.id}
            nodeId={String(row.id)}
            label={row.name}
            onClick={() => toActplan(row.id)}
            sx={{ marginBottom: '0.1rem' }}
          />
        ))}
      </TreeView>
    </List>
  );
};
export default MyGroupListItems;
